// The sections an Options menu groups its tiles into — the apps' map options sheet headings
// (Android map_options_section_navigation / _tools). Shared by the map Options dialog and the
// planner's Options so both name them the same. Each title is a literal t() call so
// I18nClientBundle ships the key to the browser.
import { i18n } from '../../../i18n';

export type OptionsSectionKey = 'navigation' | 'tools';

export const OPTIONS_SECTION_ORDER: OptionsSectionKey[] = ['navigation', 'tools'];

export function optionsSectionTitle(key: OptionsSectionKey): string {
  return key === 'tools'
    ? i18n.global.t('options_menu.section_tools')
    : i18n.global.t('options_menu.section_navigation');
}
